export const BASE_URL =
  process.env.REACT_APP_BE_URL || 'http://localhost:5000/';
export const GENERATE_COMIC_DIALOG_URL = `${BASE_URL}comic/dialog/generate`;
export const GENERATE_COMIC_URL = `${BASE_URL}comic/generate`;
export const TOKEN_BALANCE_URL = `${BASE_URL}tokens`;
export const REDEEM_CODE_URL = `${BASE_URL}tokens/redeem`;
export const TRANSACTION_HISTORY_URL = `${BASE_URL}tokens/history`;
